import { useTranslation } from 'react-i18next';
import React, { memo } from 'react';
import styles from './NoBEValidationsBanner.module.scss';

export default memo(function NoBEValidationsBanner() {
  const { t } = useTranslation();
  return <div className={styles.banner}>{t('error:routerBanner')}</div>;
});
